import { useEffect } from 'react';

export const useDisableNumberInputScroll = () => {
  useEffect(() => {
    const handleWheel = (e) => {
      e.preventDefault();
    };

    const handleKeyDown = (e) => {
      if (document.activeElement && document.activeElement.type === 'number') {
        if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
          e.preventDefault();
        }
      }
    };

    const numberInputs = document.querySelectorAll('input[type="number"]');

    numberInputs.forEach((input) => {
      input.addEventListener('wheel', handleWheel, { passive: false });
      input.addEventListener('keydown', handleKeyDown);
    });

    return () => {
      numberInputs.forEach((input) => {
        input.removeEventListener('wheel', handleWheel);
        input.removeEventListener('keydown', handleKeyDown);
      });
    };
  }, []);
};

export default useDisableNumberInputScroll;